import { fetchItemsApi, postItemApi, updateItemReasonApi, deleteItemApi } from './api'

export const SET_ITEMS = 'SET_ITEMS';
export const UPDATING_ITEMS = 'UPDATING_ITEMS';
export const FETCHING_ITEMS = 'FETCHING_ITEMS';

function updatingItems() {
  return {
    type: UPDATING_ITEMS,
  };
}

function fetchingItems() {
  return {
    type: FETCHING_ITEMS
  }
}

function setItems(items) {
  return {
    type: SET_ITEMS,
    items: items
  };
}

export function fetchItems(shipback_id, user_token, initializing = false) {
  return function (dispatch) {
    if (initializing) {
      dispatch(fetchingItems())
    }
    return fetchItemsApi(shipback_id, user_token)
    .then(json =>
      dispatch(setItems(json))
    )
  }
}

export function postItem(item_id, reason_code, shipback_id, user_token) {
  return function (dispatch) {
    dispatch(updatingItems())
    return postItemApi(item_id, reason_code, shipback_id, user_token)
    .then(json =>
      dispatch(fetchItems(shipback_id, user_token))
    )
  }
}

export function updateItemReason(item_id, reason_code, shipback_id, user_token) {
  return function (dispatch) {
    dispatch(updatingItems())
    return updateItemReasonApi(item_id, reason_code, shipback_id, user_token)
    .then(response => {
      if (response.status == 200) {
        dispatch(fetchItems(shipback_id, user_token))
      }
    })
  }
}

export function deleteItem(item_id, shipback_id, user_token) {
  return function (dispatch) {
    dispatch(updatingItems())
    return deleteItemApi(item_id, shipback_id, user_token)
    .then(response => {
      if (response.status == 200) {
        dispatch(fetchItems(shipback_id, user_token))
      }
    })
  }
}


// WEBPACK FOOTER //
// ./app/javascript/components/actions/items.js